import SolicitationManager from './SolicitationManager';

export default SolicitationManager;